import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import {
  PageContainer,
  SectionTitle,
  Button,
  Table,
  TableCell,
  TableHeader,
  TableFormGroup,
  Divider,
  TableRow,
  fadeIn,
  Footer,
  useGoBack,
  FormRow, FormGroup, Label, Input, FormRowFull, Toggle, ToggleInput
} from '../styles/PageStyles';
import { createConnector, getAllConnectorsByFilter, updateConnector } from '../services/connectorService';
import { useToast } from '../components/common/ToastProvider';


const ConnectorDetails = () => {
  const { connectorId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [connectorDetail, setConnectorDetail] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const { showToast } = useToast();



  // For Connector Current
  useEffect(() => {
    const fetchConnectorByCode = async () => {
      try {
        const parsedconnectorId = (connectorId); // Parse entityId as a number

        let filter = {
          "code": parsedconnectorId
        }
        const response = await getAllConnectorsByFilter(filter, {});
        setConnectorDetail({
          ...response[0]
        });

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (connectorId !== 'new') {
      fetchConnectorByCode();
    } else {
      if (user) {
        setConnectorDetail({
          code: "MDL-" + new Date().getTime(),
          company_cd: user.companyCd,
          name: "",
          type: "",
          status: "active",
          latency: "",
          version: "",
          provider: "",
          performance: 0,
          costPerToken: "$0.00010"
        });
      }
    }

  }, [connectorId, user]);



  const getAttribType = (type) => {
    switch (type) {
      case 'STR':
        return 'String';
      case 'INT':
        return 'Integer';
      case 'FLOAT':
        return 'Float';
      case 'DATE':
        return 'Date';
      case 'ENTITY':
        return 'Entity';
      default:
        return type;
    }
  }
  const goBack = useGoBack();

  const saveConnector = () => {
    try {
      if (connectorDetail.id) {
        updateConnector(connectorDetail);
      } else {
        createConnector(connectorDetail);
      }
      showToast({
        message:'Connector updated successfully.',
        type: 'success'
      })
      navigate('/connector');
    } catch (error) {
      console.error('Error saving Connector:', error);

    }
  }

  const filteredProperties = (connectorDetail?.properties || []).filter((attrib) => {
    return attrib?.toLowerCase().includes(searchTerm?.toLowerCase())
  });
  const addRemoveAttribute = (index) => {
    console.log(index)
    if (typeof index === 'number') {
      // // Remove the attribute at the specified index
      // const updatedProperties = (connectorDetail?.attributes || []).filter((_, i) => i !== index);
      // setEntityDetail({ ...connectorDetail, attributes: updatedProperties });
    } else {
      // // Add a new attribute using the default model
      // const updatedProperties = [...(connectorDetail?.attributes || []), { ...defaultAttributeModel }];
      // setEntityDetail({ ...connectorDetail, attributes: updatedProperties });
    }
  };
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {connectorDetail?.name ? (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              {connectorDetail?.name}
            </span>
          ) : (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              Add Connector
            </span>
          )}
        </SectionTitle>
        <Divider />
        <FormRow>
          <FormGroup>
            <Label>Name</Label>
            <Input type="text" value={connectorDetail?.name || ''} onChange={(e) => setConnectorDetail({ ...connectorDetail, name: e.target.value })} />
          </FormGroup>
        </FormRow>
        <FormRowFull>
          <FormGroup>
            <Label>Description</Label>
            <Input type="text" value={connectorDetail?.description || ''} onChange={(e) => setConnectorDetail({ ...connectorDetail, description: e.target.value })} />
          </FormGroup>
        </FormRowFull>
        <Table>
          <thead>
            <tr>
              <TableHeader>Name </TableHeader>
              <TableHeader>

                <Button onClick={() => addRemoveAttribute()} style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem', color: 'white', backgroundColor: '#ff4444', borderColor: '#ff4444' }}>Remove</Button>
              </TableHeader>
            </tr>
          </thead>
          <tbody>
            {filteredProperties.map((attrib, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TableFormGroup>
                    <Input type="text" value={attrib || ''} onChange={(e) => {
                      const updatedProperties = [...connectorDetail.properties];
                      updatedProperties[index] = e.target.value;
                      setConnectorDetail({ ...connectorDetail, properties: updatedProperties });
                    }} />
                  </TableFormGroup>
                </TableCell>
                <TableCell>

                  <div style={{ display: 'flex', gap: '0.5rem' }}>

                    <Button onClick={() => addRemoveAttribute(index)} style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem', color: 'white', backgroundColor: '#ff4444', borderColor: '#ff4444' }}>Remove</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </Table>
        <Footer>
          <div style={{ flex: '1' }}></div>
          <Button primary onClick={() => saveConnector()}>
            <FontAwesomeIcon icon={faSave} /> Save Connector</Button>
        </Footer>




      </motion.div>

    </PageContainer>
  );
}

export default ConnectorDetails;